var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "repeat-option-warning" }, [
    _c("div", { staticClass: "repeat-option-warning__icon icon icon-info" }),
    _vm._v(" "),
    _c("strong", { staticClass: "repeat-option-warning__info" }, [
      _vm._v(
        "\n\t\t" +
          _vm._s(
            _vm.$t(
              "calendar",
              "The recurrence definition of this event is not fully supported by Nextcloud. If you edit the recurrence-options, certain recurrences may be lost."
            )
          ) +
          "\n\t"
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }